import { IgnoreObjectProps } from './documentSlice'
import { GRAPHQL_API_FILTERS } from '../../constants'
import type { Identifier, UserEntity } from '../../services/api/apiTypes'
import { gql } from 'graphql-request'

export const queryIdentifiers = (): string => {
  return gql`
    {
      attribute(booleanFilter: [{ key: ${GRAPHQL_API_FILTERS.isCategory}, value: false }]) {
        edges {
          node {
            id
            name
            internalName
          }
        }
      }
    }
  `
}

// TODO: add type for graphql response
export const mapQueryIdentifiers = (raw: any): Identifier[] => {
  try {
    const list = raw.attribute.edges.map(({ node: identifier }) => ({
      id: identifier.id,
      name: identifier.name,
      internalName: identifier.internalName
    }))

    return list
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    throw error
  }
}

export const queryIgnoreBlob = ({ datasourceId, key, value }: IgnoreObjectProps): string => {
  const idsArr = value.map((value) => '"' + value + '"') || []

  return gql`
    mutation {
      ignoreObjects(
        actionInput: {
          clientMutationId: "1",
          datasourceId: "${datasourceId}"
          objectInput: {key: ${key}, value: [${idsArr.join(',')}]}
        }
      ) {
        status
      }
    }
  `
}
export const mutationIgnoreAttributeInstance = (attributeInstanceId: string): string => {
  return gql`
    mutation {
      deleteAttributeInstance(
        attributeInstanceIds: ["${attributeInstanceId}"]
        clientMutationId: ""
      ) {
        message
      }
    }
  `
}

export const queryDocumentTemplates = (): string => {
  return gql`
    {
      attribute(booleanFilter: [{ key: ${GRAPHQL_API_FILTERS.isCategory}, value: false }]) {
        edges {
          node {
            id
            name
            internalName
          }
        }
      }
    }
  `
}

export const queryEntityById = (entityId: string): string => {
  return gql`
    {
      userEntities(id: "${entityId}") {
        edges {
          node {
            id
            name
            address
            attributesCount
            riskStatus
            type {
              edges {
                node {
                  name
                }
              }
            }
          }
        }
      }
    }`
}

export const mapEntityById = (node: any): UserEntity => {
  try {
    const entity: UserEntity = {
      id: node.id,
      name: node.name,
      address: node.address,
      type: node.type.edges[0]?.node.name,
      attributesCount: node.attributesCount,
      risky: node.riskStatus,
      deletedUserEntityReferences: []
    }

    return entity
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    throw error
  }
}

export const queryUserEntities = (entityIds: string[]) => {
  return gql`
    {
      userEntities(entityIds: ${JSON.stringify(entityIds)}) {
        edges {
          node {
            id
            name
            address
            attributesCount
            riskStatus
            type {
              edges {
                node {
                  name
                }
              }
            }
          }
        }
      }
    }
  `
}

export const queryStructuredDatasourceEntities = (documentId: string) => {
  return gql`
    {
      objects(id: "${documentId}") {
        edges {
          node {
            id
            name
            entity {
              edges {
                node {
                  id
                  name
                  address
                  attributesCount
                  riskStatus
                  type {
                    edges {
                      node {
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
}
